import React, { Component, createRef } from "react";
import { withTranslation } from "react-i18next";
import { sendResetLink, resetUsername, validateRecaptcha } from "../api/api";
import PropTypes from "prop-types";
import TextInput from "./common/TextInput";
import CheckBoxRadioInput from "./common/CheckBoxRadioInput";
import ErrorAlert from "./common/ErrorAlert";
import ReCAPTCHA from "react-google-recaptcha";
import * as CONSTANTS from "../constants";

class ForgotAccountCommon extends Component {
  constructor(props) {
    super(props);
    // console.log("### ForgotAccountCommon => START ");

    let accountType = '';

    if (this.props.clientInfo[CONSTANTS.PRODUCT_TYPE_GSM] === 'Y') {
      accountType = CONSTANTS.PRODUCT_TYPE_GSM
    } else if (this.props.clientInfo[CONSTANTS.PRODUCT_TYPE_CONNECT] === 'Y') {
      accountType = CONSTANTS.PRODUCT_TYPE_CONNECT
    } else if (this.props.clientInfo[CONSTANTS.PRODUCT_TYPE_FTTH] === 'Y') {
      accountType = CONSTANTS.PRODUCT_TYPE_FTTH
    }

    this.state = {
      errors: { username: "", recaptcha: "", sendBy: "" },
      formIsValid: false,
      loading: false,
      genericError: null,
      username: this.props.username,
      formType: this.props.formType,
      userType: this.props.userType,
      productType: this.props.productType,
      transactionId: this.props.transactionId,
      mobile_number: "",
      service_account_number: "",
      account_number: "",
      recpatchValidateFlag: true,
      recaptchaRes: "",
      identification_number: "",
      // mobily_number: "",
      email_address: "",
      commercial_id: "",
      by:
        this.props.userType != CONSTANTS.USER_TYPE_NON_MOBILY
          ? CONSTANTS.ACCOUNT_TYPE_MOBILE
          : "",
      sendBy:
        this.props.sendBy.length > 1 && this.props.sendBy.includes("SMS")
          ? "SMS"
          : this.props.sendBy[0],
      showSuccessMsg: false,
    };
  }

  setShowSuccessMsg = (param) => {
    // console.log("tabs param: " + param);
    this.props.setShowSuccessMsg(true);
    this.setState({
      showSuccessMsg: param,
    });
  };

  validateRecaptchServerSide = async () => {
    const result = await validateRecaptcha(this.state.recaptchaRes);
    console.log("Result:" + result);
    if (result.data.validationStatus == false) {
      this.setState({
        recpatchValidateFlag: false,
      });
    }

  }
  handleValidation(formData) {
    // console.log("ForgotAccount :: handleValidation :: Enter");

    let errors = {};
    let formIsValid = false;

    for (var [key, value] of formData) {
      // console.log("ForgotAccount :: handleValidation :: name => " + key);
      // console.log(" :: handleValidation :: value => [" + value + "]");

      if (key === "mobile_number") {
        // console.log("ap mobile validation");
        if (value === null || value === "") {
          errors[key] = "required";
        } else if (typeof value !== "undefined") {
          if (!value.match(/^[0-9]*$/)) {
            errors[key] = "msisdn_format";
          }
        }
      }
      //EMAIL
      if (key === "email_address") {
        // console.log(" validation email ");
        if (typeof value !== "undefined" && value !== "") {
          // console.log("in not undefined");
          let lastAtPos = value.lastIndexOf("@");
          let lastDotPos = value.lastIndexOf(".");

          if (
            !(
              lastAtPos < lastDotPos &&
              lastAtPos > 0 &&
              value.indexOf("@@") === -1 &&
              lastDotPos > 2 &&
              value.length - lastDotPos > 2
            )
          ) {
            errors[key] = "invalid_email";
          }
        }
      }

      // commercial_id
      if (key === "commercial_id") {
        // console.log("commercial_id validation, value[" + value + "]");
        if (value === null || value === "") {
          errors["commercial_id"] = "required";
        } else if (typeof value !== "undefined") {
          if (!value.match(/^[a-zA-Z0-9_]*$/)) {
            errors["commercial_id"] = "commercial_id_format";
          }
        }
      }

      // service account number
      if (key === "service_account_number") {
        if (value === null || value === "") {
          errors["service_account_number"] = "required";
        } else if (typeof value !== "undefined") {
          if (!value.match(/^[0-9]*$/)) {
            errors["service_account_number"] = "service_account_format";
          }
        }
      }

      // account number
      if (key === "account_number") {
        if (value === null || value === "") {
          errors["account_number"] = "required";
        } else if (typeof value !== "undefined") {
          if (!value.match(/^[0-9]*$/)) {
            errors["account_number"] = "service_account_format";
          }
        }
      }

      if (key !== "g-recaptcha-response") {
        if (value === null || value === "") {
          errors[key] = "required";
        }
      }

      if (key === "g-recaptcha-response") {
        console.log("recaptcha response:" + value);
        this.state.recaptchaRes = value;
        if (!value) {
          //formIsValid = false;
          errors["recaptcha"] = "required";
        }
      }

    }
    // console.log(" ===> JSON.stringify(errors) " + JSON.stringify(errors));
    if (JSON.stringify(errors) === "{}") {
      formIsValid = true;
    }

    this.setState({ errors: errors, genericError: null });
    return formIsValid;
  }

  handaleSubmit = async (e) => {
    e.preventDefault();
    if (this.props.formType === CONSTANTS.FORM_TYPE_FORGOT_USERNAME) {
      // console.log("it is username");
      this.handaleSubmit_Username(e);
    } else {
      // console.log("it is password");
      this.handaleSubmit_Password(e);
    }
  };

  handaleSubmit_Username = async (e) => {
    let formIsValid = false;
    // console.log("before ==> handaleSubmit_Username :: formIsValid => " + formIsValid);
    const formData = new FormData(e.target);

    formIsValid = this.handleValidation(formData.entries());

    // console.log("after ==> handaleSubmit_Username :: formIsValid => " + formIsValid);

    e.preventDefault();
    if (formIsValid) {
      await this.resetUsername();
    }
  };

  resetUsername = async () => {
    let requestBody = {
      userType: this.props.userType,
      preferredLanguage: "EN",
      consumerInfo: {
        idNumber: this.state.identification_number,
        accountNumber:
          this.state.by === CONSTANTS.ACCOUNT_TYPE_MOBILE
            ? this.state.mobile_number
            : this.state.account_number,
        messageType: this.state.sendBy,
      },
      corporateInfo: {
        billingAccountNumber: this.state.account_number,
        apMobileNumber: this.state.mobile_number,
        commercialId: this.state.commercial_id,
      },
      nonMobilyInfo: {
        email: this.state.email_address,
      },
      clientInfo: {
        clientId: this.props.clientId,
        ...(this.props.clientId !== window.OAUTHUserName && {
          redirectUrl: this.props.redirectURL,
        })
      },
    };

    this.setState({
      loading: true,
    });

    try {
      // API CALL - SEND RESET REQUEST
      let result = await resetUsername(requestBody);
      // console.log("ForgotAccount :: resetUsername :: result => " + JSON.stringify(result));

      // console.log("============> usertype : " + this.state.userType);
      // console.log("============> productType : " + this.state.productType);

      this.setShowSuccessMsg(true);

      this.props.setMessageDetails({
        headerMsg:
          this.state.sendBy === "SMS" ? "id_sent_by_sms" : "id_sent_by_email",
        descriptionMsg: "",
        btnLabel: "go_to_home",
        loginUrl: result.loginUrl,
        returnUrl: this.props.redirectURL != "" ? this.props.redirectURL : "/wps/portal/web",
      });

      this.setState({
        isSuccess: true,
        genericError: null,
        loading: false,
      });
    } catch (error) {
      console.log("ForgotAccountCommon :: resetUsername :: Error => " + error);
      this.setState({
        genericError: error,
        loading: false,
        //just to test i have to remove it
        //isSuccess:true,
      });
    }
  };

  handaleSubmit_Password = async (e) => {
    let formIsValid = false;
    const formData = new FormData(e.target);

    formIsValid = this.handleValidation(formData.entries());
    this.validateRecaptchServerSide();
    // console.lsog("after ==> handaleSubmit :: formIsValid => " + formIsValid);
    console.log("After recaptcha validation");
    e.preventDefault();
    if (formIsValid && this.state.recpatchValidateFlag == true) {
      await this.sendResetRequest();
    }
  };

  sendResetRequest = async () => {
    let requestBody = {
      transactionId: this.state.transactionId,
      userType: this.state.userType,
      productType: this.state.productType,
      msisdn: this.state.userType === CONSTANTS.USER_TYPE_INDIVIDUAL &&
        (this.props.productType === CONSTANTS.PRODUCT_TYPE_CONNECT ||
          this.props.productType === CONSTANTS.PRODUCT_TYPE_FTTH) ? this.state.service_account_number : this.state.mobile_number,
      billingAccountNumber: this.state.account_number,
      apMobileNumber: this.state.mobile_number,
      email: this.state.email_address,
      // messageType: this.state.sendBy,
      messageType: this.state.userType === CONSTANTS.USER_TYPE_NON_MOBILY ? "Email" : this.state.sendBy,

    };

    this.setState({
      loading: true,
    });

    try {
      // API CALL - SEND RESET REQUEST
      let result = await sendResetLink(requestBody);
      console.log("ForgotAccount :: User Info :: result => " + JSON.stringify(result));

      // console.log("============> usertype : " + this.state.userType);
      // console.log("============> productType : " + this.state.productType);

      this.setShowSuccessMsg(true);


      this.props.setMessageDetails({
        headerMsg:
          this.state.sendBy === "SMS"
            ? "password_sent_by_sms"
            : "password_sent_by_email",
        descriptionMsg: "",
        btnLabel: "go_to_home",
        loginUrl: result.loginUrl,
        returnUrl: this.props.redirectURL != "" ? this.props.redirectURL : "/wps/portal/web",
      });

      this.setState({
        isSuccess: true,
        genericError: null,
        loading: false,
      });
    } catch (error) {
      console.log("ForgotAccountCommon :: sendResetRequest :: Error => " + error);
      console.log("ForgotAccountCommon :: sendResetRequest :: Error => " + error.message);
      this.setState({
        genericError: error,
        loading: false,
        //just to test i have to remove it
        //isSuccess:true,
      });
    }
  };

  handleChange = async (e) => {
    // console.log(" => handleChange => Enter " + e.target.value);
    // console.log(" => handleChange => Enter  " + e.target.name);
    e.persist();
    // this.setState({ formIsValid: true });
    this.setState({
      [e.target.name]: e.target.value,
    });

    // CHECK USERNAME VALIDITY
    /*if (e.target.name === 'username'){
          await this.verifyUsername(e.target.value)        
      }*/
  };

  recaptchaRef = createRef();

  render() {
    const { loading } = this.state;
    const { t } = this.props;
    // console.log("---> this.props.formType :" + this.props.formType);
    // console.log("---> this.props.userType :" + this.props.userType);
    // console.log("---> this.state.by :" + this.state.by);
    // console.log("---> this.state.sendBy :" + this.state.sendBy);
    return (
      <div>
        {this.state.genericError && <ErrorAlert error={this.state.genericError} />}
        <form id="forgot-account-form" onSubmit={this.handaleSubmit}>
          <label
            className="input-label"
            style={{
              visibility: this.state.username ? "visible" : "hidden",
            }}
          >
            {t("username")}
          </label>
          <br />
          <label className="input-label">{this.state.username}</label>
          <br />

          {/* BY: FOR FORGOT USERNAME - INDIVIDUAL */}
          {this.props.formType === CONSTANTS.FORM_TYPE_FORGOT_USERNAME &&
            this.props.userType === CONSTANTS.USER_TYPE_INDIVIDUAL ? (
            <div className="">
              <label
                className="input-label"
                style={{ display: "inline-block" }}
              >
                {t("by")}
              </label>
              <CheckBoxRadioInput
                label={"by_mobile"}
                name={"by"}
                value={CONSTANTS.ACCOUNT_TYPE_MOBILE}
                type={"radio"}
                handleChange={this.handleChange}
                checked={this.state.by === CONSTANTS.ACCOUNT_TYPE_MOBILE}
                disabled={false}
                singleLine={true}
                render={true}
              />
              <CheckBoxRadioInput
                label={"by_internet_account"}
                name={"by"}
                value={CONSTANTS.ACCOUNT_TYPE_INTERNET}
                type={"radio"}
                handleChange={this.handleChange}
                checked={this.state.by === CONSTANTS.ACCOUNT_TYPE_INTERNET}
                disabled={false}
                singleLine={true}
                render={true}
              />
            </div>
          ) : null}

          <TextInput
            type="text"
            label="service_account_number"
            name="service_account_number"
            maxLength="20"
            render={
              this.props.formType === CONSTANTS.FORM_TYPE_FORGOT_PASSWORD &&
              this.props.userType === CONSTANTS.USER_TYPE_INDIVIDUAL &&
              (this.props.productType === CONSTANTS.PRODUCT_TYPE_CONNECT ||
                this.props.productType === CONSTANTS.PRODUCT_TYPE_FTTH)
            }
            handleChange={this.handleChange}
            error={this.state.errors.service_account_number}
          />
          <TextInput
            type="text"
            label="account_number"
            name="account_number"
            maxLength="20"
            render={
              this.props.userType === CONSTANTS.USER_TYPE_CORPORATE ||
              this.state.by === CONSTANTS.ACCOUNT_TYPE_INTERNET
            }
            handleChange={this.handleChange}
            error={this.state.errors.account_number}
          />
          <TextInput
            type="text"
            label="mobile_number"
            name="mobile_number"
            maxLength="12"
            render={
              (this.props.formType === CONSTANTS.FORM_TYPE_FORGOT_PASSWORD &&
                this.props.userType === CONSTANTS.USER_TYPE_INDIVIDUAL &&
                this.props.productType === CONSTANTS.PRODUCT_TYPE_GSM) ||
              (this.props.formType === CONSTANTS.FORM_TYPE_FORGOT_PASSWORD &&
                this.props.userType === CONSTANTS.USER_TYPE_CORPORATE) ||
              (this.props.formType === CONSTANTS.FORM_TYPE_FORGOT_USERNAME &&
                this.props.userType === CONSTANTS.USER_TYPE_CORPORATE) ||
              (this.props.formType === CONSTANTS.FORM_TYPE_FORGOT_USERNAME &&
                this.props.userType === CONSTANTS.USER_TYPE_INDIVIDUAL &&
                this.state.by === CONSTANTS.ACCOUNT_TYPE_MOBILE)

            }
            handleChange={this.handleChange}
            error={this.state.errors.mobile_number}
          />
          <TextInput
            type="text"
            label="identification_number"
            name="identification_number"
            render={
              (this.props.formType === CONSTANTS.FORM_TYPE_FORGOT_USERNAME &&
                this.props.userType === CONSTANTS.USER_TYPE_INDIVIDUAL)
            }
            handleChange={this.handleChange}
            error={this.state.errors.identification_number}
          />
          {/* <TextInput
            type="text"
            label="mobily_number"
            name="mobily_number"
            render={
              this.props.formType === CONSTANTS.FORM_TYPE_FORGOT_PASSWORD &&
              this.props.userType === CONSTANTS.USER_TYPE_CORPORATE
            }
            handleChange={this.handleChange}
            error={this.state.errors.mobily_number}
          /> */}
          <TextInput
            type="text"
            label="email_address"
            name="email_address"
            render={this.props.userType === CONSTANTS.USER_TYPE_NON_MOBILY}
            handleChange={this.handleChange}
            error={this.state.errors.email_address}
          />
          <TextInput
            type="text"
            label="commercial_id"
            name="commercial_id"
            render={
              this.props.formType === CONSTANTS.FORM_TYPE_FORGOT_USERNAME &&
              this.props.userType === CONSTANTS.USER_TYPE_CORPORATE
            }
            handleChange={this.handleChange}
            error={this.state.errors.commercial_id}
          />
          <br />

          {/* SEND BY */}
          {this.state.sendBy != "" && this.state.sendBy ? (
            <div className="">
              <label
                className="input-label"
                style={{ display: "inline-block" }}
              >
                {t("send_by")}
              </label>
              {this.props.sendBy.includes("SMS") ? (
                <CheckBoxRadioInput
                  label={"send_by_mobile"}
                  name={"sendBy"}
                  value={"SMS"}
                  type={"radio"}
                  handleChange={this.handleChange}
                  checked={this.state.sendBy === "SMS"}
                  disabled={false}
                  singleLine={true}
                  render={this.state.by === "mobile"}
                />
              ) : null}
              {this.props.sendBy.includes("Email") ? (
                <CheckBoxRadioInput
                  label={"send_by_email"}
                  name={"sendBy"}
                  value={"Email"}
                  type={"radio"}
                  handleChange={this.handleChange}
                  checked={this.state.sendBy === "Email"}
                  disabled={false}
                  singleLine={true}
                  render={true}
                />
              ) : null}
            </div>
          ) : null}

          {/* ReCAPTCHA PART */}
          <ReCAPTCHA
            ref={this.recaptchaRef}
            className="mt-4"
            sitekey={window.CAPTCHA_V2_SITE_KEY}
            type="image"
            hl={window.lang === "ar" ? "ar" : "en"}
            name={"recaptcha"}
          />
          {this.state.errors.recaptcha && (
            <ErrorAlert error={this.state.errors.recaptcha} />
          )}

          <button
            type="submit"
            className="btn min_outlin_btn active"
            // onClick={this.handaleSubmit}
            disabled={this.state.formIsValid}
          >
            {t("send_btn")}{" "}
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
          {this.props.formType === CONSTANTS.FORM_TYPE_FORGOT_PASSWORD && (
            <button
              type="button"
              className="btn min_outlin_btn"
              onClick={() => {
                this.resetForm();
              }}
            >
              {t("reset_btn")}{" "}
              <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          )}
        </form>
        {loading ? <div className="loading">Loading&#8230;</div> : null}
      </div>
    );
  }
  resetForm() {
    this.props.resetForm();
  }
}

ForgotAccountCommon.propTypes = {
  username: PropTypes.string,
  formType: PropTypes.string,
  userType: PropTypes.string,
  productType: PropTypes.string,
  sendBy: PropTypes.arrayOf(PropTypes.string),
};
export default withTranslation()(ForgotAccountCommon);
